import React from 'react';
import Table from '@/common/components/Table';
import { DetailSection, DetailTitle, Evidence } from '../../callAnalysis.styles';
import { getResultColor, getResultLabel } from '../../helpers/labels';

const HEADERS = ['Criterion', 'Status', 'Details'];

const CriteriaSection = ({ sections }) => {
	const hasCriteria = sections?.some((section) => section.criteria?.length);
	if (!hasCriteria) {
		return null;
	}

	const raws = sections.flatMap((section) =>
		(section.criteria || []).map((criterion) => (
			<tr key={`${section.section_id}-${criterion.criterion_id}`}>
				<td>{criterion.label || criterion.criterion_id}</td>
				<td
					style={{
						color: getResultColor(criterion.result),
						fontWeight: 600,
					}}
				>
					{getResultLabel(criterion.result)}
				</td>
				<td>
					{criterion.missing_or_incorrect || criterion.evidence || '—'}
					{(criterion.timestamp ||
						criterion.evidence ||
						criterion.missing_or_incorrect) && (
						<Evidence>
							{criterion.timestamp ? `Time: ${criterion.timestamp}` : null}
							{criterion.timestamp && criterion.evidence ? ' · ' : null}
							{criterion.evidence && criterion.missing_or_incorrect
								? criterion.evidence
								: null}
						</Evidence>
					)}
				</td>
			</tr>
		)),
	);

	return (
		<DetailSection>
			<DetailTitle>Detailed criteria</DetailTitle>
			<Table className='styled-table' headers={HEADERS} raws={raws} />
		</DetailSection>
	);
};

export default CriteriaSection;
